module.exports = __webpack_public_path__ + "static/img/label-04.88649e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/label-04.png
// module id = B6fg
// module chunks = 31